<div class="modal-header">
    <h2 mat-dialog-title>{{ data?.noteId ? 'Edit remark' : 'Add remark' }}</h2>
    <button mat-icon-button (click)="dismiss()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <form [formGroup]="formGroup" class="note-form">
        <div class="note-info">
            <p><strong>Subject:</strong> {{ this.data?.subject }}</p>
            <p><strong>Description:</strong> {{ this.data?.description }}</p>
        </div>

        <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Remark</mat-label>
                <textarea matInput placeholder="Remark" rows="6" formControlName="remark" cdkFocusInitial></textarea>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="saveRemark()" [disabled]="formGroup.invalid || isSaving">
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">Saving...</span>
    </button>
</mat-dialog-actions>